
const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/b531b6b230ccc407b74ca6076107ac2d.png"
          alt="岡山市の整形外科クリニックで患者と対話する日本人医師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <div className="inline-block border-2 border-white bg-transparent px-5 py-2 rounded-full mb-8">
          <span className="text-white text-sm font-medium tracking-wide">岡山市北区の整形外科</span>
        </div>
        
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          痛みに寄り添い、<br />
          動ける喜びを取り戻す
        </h1>
        
        <p className="text-lg md:text-xl text-white/95 leading-relaxed max-w-3xl mx-auto">
          地域の皆様の健康な日常生活をサポートする、信頼の整形外科クリニック
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
